import { createSelector } from '@ngrx/store';
import { getDragonflySchemasState } from '../reducers';

export const getSchemasSearchState = createSelector(getDragonflySchemasState, (state) => state?.search);

export const getNexus = createSelector(getSchemasSearchState, (state) => state?.nexus);

export const getCompanies = createSelector(getSchemasSearchState, (state) => state?.companies);

export const getLevels = createSelector(getSchemasSearchState, (state) => state?.levels);

export const getTaxOffices = createSelector(getSchemasSearchState, (state) => state?.taxOffices);

export const getRedemptionTypes = createSelector(getSchemasSearchState, (state) => state?.redemptionTypes);

export const getCountries = createSelector(getSchemasSearchState, (state) => state?.countries);

export const getPanelExpanded = createSelector(getSchemasSearchState, (state) => state?.panelExpanded);

export const getSideNav = createSelector(getSchemasSearchState, (state) => state?.sideNav);

export const getSchemaCode = createSelector(getSchemasSearchState, (state) => state?.schemaCode);

export const getCompanyTitle = createSelector(getSchemasSearchState, (state) => state?.companyTitle);

export const getVATNumber = createSelector(getSchemasSearchState, (state) => state?.vatNumber);
